export function isWebview() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return (
    /wv|webview|web-browser/i.test(userAgent) ||
    (window && window.ReactNativeWebView) ||
    /FBAN|FBAV/i.test(userAgent)
  ); // Checks for common webview indicators
}
